import React from 'react';
import { Button, Stack } from '@mui/material';

import { PropertyTextInput } from '@paragon/client-tools';
import { KeyToValueOfType } from '@paragon/utilities';

import { ReferenceLineWithReferenceLineComponents } from '../../../../store/actions/insertActions';
import {
  clearHighlightedReferenceLineGuids,
  setHighlightedReferenceLineGuids,
} from '../../../../store/slices/viewportSlice';
import { useAppDispatch } from '../../../hooks';

interface Props<T extends ReferenceLineWithReferenceLineComponents, K extends KeyToValueOfType<T, string | null>> {
  referenceLineLongNamesByGuid: ReadonlyMap<string, string>;
  line: T;
  disabled?: boolean;
  lineKey: K;
  propertyTitle: string;
  startSetReferenceLineGuid: (line: T, key: K) => void;
}

export default <T extends ReferenceLineWithReferenceLineComponents, K extends KeyToValueOfType<T, string | null>>(
  props: Props<T, K>,
) => {
  const dispatch = useAppDispatch();

  const { disabled, line, lineKey, propertyTitle, referenceLineLongNamesByGuid } = props;

  const referencedLineGuid = line[lineKey] as unknown as string | null;

  return (
    <Stack
      direction="row"
      spacing={1}
      onMouseEnter={() => {
        if (referencedLineGuid) dispatch(setHighlightedReferenceLineGuids(referencedLineGuid));
      }}
      onMouseLeave={() => {
        dispatch(clearHighlightedReferenceLineGuids());
      }}
    >
      <PropertyTextInput
        disabled
        property={propertyTitle}
        value={(referencedLineGuid && referenceLineLongNamesByGuid.get(referencedLineGuid)) || ''}
      />

      <Button
        variant="outlined"
        disabled={disabled}
        onClick={() => {
          props.startSetReferenceLineGuid(line, lineKey);
        }}
      >
        Pick
      </Button>
    </Stack>
  );
};
